<template>
  <admin-page-shell
    :title="$t('frontend_groovemail_admin_user_sender_title')"
  >
    <server-table
      class="text-center groovemail-user-senders-table"
      ref="serverTable"
      :url="sendersListingUrl"
      tableRef="sendersTable"
      tableTitle="frontend_groovemail_admin_user_sender_title"
      :slotData="userSenderSlotData"
      :tableColumns="sendersTableColumns"
      :tableOptions="sendersTableOptions"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { mapActions } from "vuex";
import { adminUrls } from '@/utils/urls.js';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_user_sender_title') };
  },

  mixins: [demoModeValuesMixin],

  data() {
    return {
      tableKey: 1,
      sendersListingUrl: adminUrls.userSendersUrl.sendersListing,
      sendersTableColumns: [
        'user.name',
        'name',
        'sender_name',
        'sender_email',
        'reply_email',
        'is_verified',
        'is_default',
      ],
      sendersTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['sender_name', 'sender_email', 'reply_email'],
        filterable: ['sender_email'],
        headings: {
          'user.name': () =>
            this.$t('frontend_groovemail_admin_user_sender_user_name'),
          name: () =>
            this.$t('frontend_groovemail_segment_subscribe_sender_identity'),
          sender_name: () =>
            this.$t('frontend_groovemail_segment_subscribe_sender_name'),
          sender_email: () =>
            this.$t('frontend_groovemail_segment_subscribe_sender_email'),
          reply_email: () =>
            this.$t('frontend_groovemail_segment_subscribe_reply_email'),
          is_verified: () =>
            this.$t('frontend_groovemail_admin_user_sender_verified'),
          is_default: () => this.$t('frontend_groovemail_smtp_mail_default'),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              reply_email: self.basicEmailText,
              sender_email: self.basicEmailText,
              sender_name: self.basicText,
              user: {
                id: obj?.user?.id,
                name: self.basicText,
                email: self.basicEmailText,
                username: self.basicEmailText}
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },
    };
  },

  components: {
    AdminPageShell,
    ServerTable,
  },

  created() {
    self = this;
  },

  watch: {
    // Used to refresh senders table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.sendersTable.refresh();
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    /**	
     * Returns slot data for user sender table.	
     * @return {array} details for slot columns for user sender table.	
    */
    userSenderSlotData() {
      return [
        {
          slotName: 'is_verified',
          slotType: 'computed',
          classes: () => {
            return 'text-sm';
          },
          value: (props) => {
            return props.row.is_verified
              ? this.$t('frontend_yes_I_am_sure')
              : this.$t('frontend_no');
          },
        },
        {
          slotName: 'is_default',
          slotType: 'computed',
          classes: () => {
            return 'text-sm';
          },
          value: (props) => {
            return props.row.is_default
              ? this.$t('frontend_yes_I_am_sure')
              : this.$t('frontend_no');
          },
        },
      ];
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },
  },
};
</script>

<style lang="scss">
.groovemail-user-senders-table #gd-server-table-view .VueTables__table th:last-child span {
  display: block;
}
</style>
